"use client";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import axios from "axios";
import toastify from "../../config/toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faBell,
  faSave,
  faUpload,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

export default function ProductAdd() {
  const [formval, setFormval] = useState({
    productName: "",
    details: "",
    whatsappNumber: 0,
    link: "",
    image: "",
    status: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormval((prevVal) => ({
      ...prevVal,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };


  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeFile = () => {
    setSelectedFile(null);
    setPreviewUrl(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formval.productName) {
      return toastify.error("Product name is required");
    }
    if (!formval.details) {
      return toastify.error("Product details are required");
    }
    if (!formval.status) {
      return toastify.error("Status is required");
    }

    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("productName", formval.productName);
      formData.append("details", formval.details);
      formData.append("whatsappNumber", formval.whatsappNumber);
      formData.append("link", formval.link);
      formData.append("status", formval.status);

      if (selectedFile) {
        formData.append("image", selectedFile);
      }

      const response = await axios({
        // url: `http://localhost:3000/admin/product/create`,
        url: `${baseUrl}/admin/product/create`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: formData,
      });

      toastify.success("Product created successfully");
      navigate("/products");
    } catch (error) {
      console.error("Error:", error);
      toastify.error("Failed to create product");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="main-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="dashboard-title">
                <h4 className="dash-head">
                  <FontAwesomeIcon icon={faBell} className="me-2" />
                  Add Prodect
                </h4>
              </div>
              <div className="custom-bredcump">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/products">Product</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Add Product
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="col-lg-6 d-flex justify-content-end">
              <Link to="/products" className="btn btn-info text-white">
                <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                Back
              </Link>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="cards edit-usr">
                <form onSubmit={handleSubmit}>
                  {/* Basic Information */}
                  <div className="form-section">
                    <h5 className="section-title">Product Details</h5>
                    <div className="row">
                      <div className="col-lg-12 mb-4">
                        <label htmlFor="productName" className="form-label">
                          Product Name<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="productName"
                          placeholder="Enter product Name"
                          onChange={changeHandler}
                          value={formval?.productName}
                        />
                      </div>
                      <div className="col-lg-12 mb-4">
                        <label htmlFor="details" className="form-label">
                          Details<sup className="text-danger">*</sup>
                        </label>
                        <textarea
                          className="form-control"
                          name="details"
                          rows="4"
                          placeholder="Enter product details"
                          onChange={changeHandler}
                          value={formval?.details}
                        ></textarea>
                      </div>
                      <div className="col-lg-12 mb-4">
                        <label htmlFor="whatsappNumber" className="form-label">
                          WhatsApp Number<sup className="text-danger"></sup>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="whatsappNumber"
                          placeholder="Enter whatsapp Number"
                          onChange={changeHandler}
                          value={formval?.whatsappNumber}
                        />
                      </div>
                      <div className="col-lg-12 mb-4">
                        <label htmlFor="link" className="form-label">
                          webSite Link<sup className="text-danger"></sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="link"
                          placeholder="Enter website link"
                          onChange={changeHandler}
                          value={formval?.link}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Notification Image */}
                  <div className="form-section mb-5">
                    <h5 className="section-title">Product Image</h5>
                    <div className="file-upload-container">
                      <div
                        className={`file-upload-area ${
                          isDragging ? "dragging" : ""
                        }`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                      >
                        {!selectedFile ? (
                          <>
                            <div className="file-upload-icon">
                              <FontAwesomeIcon icon={faUpload} />
                            </div>
                            <div className="file-upload-text">
                              Drag & Drop your image here
                            </div>
                            <div className="file-upload-subtext">
                              or click to browse files
                            </div>
                            <input
                              type="file"
                              className="file-upload-input"
                              accept="image/*"
                              onChange={handleFileChange}
                            />
                          </>
                        ) : (
                          <div className="file-preview-container">
                            <img
                              src={previewUrl || "/placeholder.svg"}
                              alt="Preview"
                              className="file-preview"
                            />
                            <button
                              type="button"
                              className="file-remove-btn"
                              onClick={removeFile}
                            >
                              <FontAwesomeIcon icon={faTimes} />
                            </button>
                            
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Status */}
                  <div className="form-section">
                    {/* <h5 className="section-title">Status</h5> */}
                    <div className="row">
                      <div className="col-lg-6 mb-4">
                        <label htmlFor="status" className="form-label">
                          Status<sup className="text-danger">*</sup>
                        </label>
                        <select
                          className="form-control"
                          name="status"
                          onChange={changeHandler}
                          value={formval?.status}
                        >
                          <option value="">Select Status</option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12 text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-for-add text-white"
                      disabled={loading}
                    >
                      {loading && <div className="loading-spinner"></div>}
                      <FontAwesomeIcon icon={faSave} className="me-2" />
                      {loading ? "Creating..." : "Create Product"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
